import { render, staticRenderFns } from "./MyCarousel.vue?vue&type=template&id=9329ba34&scoped=true&"
import script from "./MyCarousel.vue?vue&type=script&lang=js&"
export * from "./MyCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MyCarousel.vue?vue&type=style&index=0&id=9329ba34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9329ba34",
  null
  
)

export default component.exports